import { Component, Input, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { Navigator } from "src/app/services/routing/navigator";
import { UtilsService } from 'src/app/services/utils/utils.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-popover-alert',
  templateUrl: './popover-alert.component.html',
  styleUrls: ['./popover-alert.component.scss'],
})
export class PopoverAlertComponent implements OnInit {

  @Input() data: any;
  imageUrl: string;
  image: string;
  private notificationEvent;

  constructor(
    private sanitizer: DomSanitizer,
    public popoverController: PopoverController,
    public navigator: Navigator,
    private navParams: NavParams,
    public utils: UtilsService
  ){}


  public onClosePopover() {
    this.popoverController.dismiss(true);
    this.notificationClose();
  }

  get sanitizedHtmlText() {
    return this.sanitizer.bypassSecurityTrustHtml(this.data.htmlText);
  }

  notificationClose() {
    if (this.notificationEvent.onCloseFunc){
      this.notificationEvent.onCloseFunc('closeButton');
    }
  }

  ngOnInit(): void {
    this.notificationEvent = this.navParams.data.data;
    
    this.imageUrl = `/notifications/${this.data.notificationImage}`;
    this.image = this.utils.getCDNAsset(this.imageUrl)
    if (this.data.timeout) {
      setTimeout(()=>{
        this.onClosePopover();
      },+this.data.timeout);
    }
  }

}
